var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeRoadNum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 88 88",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "#000",
    fillOpacity: 0.4,
    rx: 44
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.6 42.276q0 2.196-.325 4.392a16.7 16.7 0 0 1-1.08 4.104 11.2 11.2 0 0 1-2.124 3.42q-1.368 1.476-3.492 2.34-2.124.828-5.112.828-.756 0-1.728-.072t-1.584-.252v-3.204q1.44.432 3.168.432 2.448 0 4.068-.72 1.656-.756 2.592-2.088t1.368-3.096.504-3.744h-.216q-.792 1.224-2.196 2.124-1.404.864-3.78.864-3.348 0-5.364-2.052-1.98-2.088-1.98-5.832 0-4.068 2.268-6.408t6.084-2.34q2.52 0 4.536 1.224t3.204 3.744q1.188 2.484 1.188 6.336m-8.893-8.172q-2.052 0-3.348 1.368t-1.296 4.176q0 2.304 1.116 3.636t3.384 1.332q1.584 0 2.736-.648t1.8-1.656.648-2.088q0-1.44-.576-2.844a5.5 5.5 0 0 0-1.692-2.34q-1.116-.936-2.772-.936"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50.81 71.236a20.6 20.6 0 0 1-3.234.588 32 32 0 0 1-3.234.176q-5.527 0-10.437-1.968t-8.732-5.434-6.233-8.165T16 46.27h3.587a21.6 21.6 0 0 0 2.41 8.4 25.8 25.8 0 0 0 5.264 6.932c2.136 1.998 7.29 4.847 7.29 4.847l4.986-4.905zM37.19 16.764q1.532-.411 3.24-.588A32 32 0 0 1 43.728 16q5.478 0 10.426 1.968t8.746 5.434 6.215 8.165T72 41.73h-3.534a21.6 21.6 0 0 0-2.415-8.4 25.8 25.8 0 0 0-5.272-6.932c-2.14-1.998-7.304-4.847-7.304-4.847l-4.993 4.905z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeRoadNum);
export default __webpack_public_path__ + "static/media/ChangeRoadNum.482acad2ccf7d2f8a3460a3a974c4253.svg";
export { ForwardRef as ReactComponent };